import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import ReactTable from "react-table"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import { pipsyTheme } from "../../graphTheme"
import { Link } from "react-router-dom"
import { Bar } from "react-chartjs-2"
import clone from 'clone'

let limit = 20

class Inventory extends Component {
    constructor(props) {
        super(props)

        this.state = {
            columns: [
                {
                    Header: "Section",
                    accessor: "section",
                    display: true,
                },
                {
                    Header: "Builder",
                    accessor: "builder",
                    display: true,
                },
                {
                    Header: "ISD",
                    accessor: "isd",
                    display: true,
                },
                {
                    Header: "Remaining Lots",
                    accessor: "remaining",
                    display: true,
                },
                {
                    Header: "Total Lots",
                    accessor: "total",
                    display: true,
                },
                {
                    Header: "Spec Homes",
                    accessor: "spec_homes",
                    display: true,
                },
                {
                    Header: "Model Homes",
                    accessor: "model_homes",
                    display: true,
                },
                {
                    Header: "Vacant Lots",
                    accessor: "vacant_lots",
                    display: true,
                },
                {
                    Header: "Under Contract",
                    accessor: "contract",
                    display: true,
                },
                {
                    Header: "Homes Closed",
                    accessor: "closed",
                    display: true,
                },
                {
                    Header: "Takedown",
                    accessor: "takedown",
                    display: true,
                },
                {
                    Header: "Slab",
                    accessor: "slab",
                    display: true,
                },
                {
                    Header: "Complete",
                    accessor: "complete",
                    display: true,
                },
                {
                    Header: "Weekly Sales Avg - 6 Mo",
                    accessor: "sixWeeklyAverage",
                    display: true,
                },
                {
                    Header: "Weekly Sales Avg - 12 Mo",
                    accessor: "twelveWeeklyAverage",
                    display: true,
                },
                {
                    Header: "Months Remaining",
                    accessor: "monthsRemaining",
                    display: true,
                },
            ],
        }
    }
    developerLots = () => {
        var count = 0
        _.forEach(this.props.payload.exec.lots, r => {
            if (r.status == "Off-Market") {
                count++
            }
        })
        return count
    }

    specHomesTotal = () => {
        var count = 0
        _.forEach(this.props.payload.exec.lots, r => {
            if (r.status == "Available Home") {
                count++
            }
        })
        return count
    }

    comingSoon = () => {
        var count = 0
        _.forEach(this.props.payload.exec.lots, r => {
            if (r.status == "Coming Soon") {
                count++
            }
        })
        return count
    }

    supply = () => {
        var store = {}
        var six = moment()
            .subtract(6, "months")
            .unix()
        var twelve = moment()
            .subtract(12, "months")
            .unix()
        let now = moment.unix()
        // First number of remaining lots
        _.forEach(this.props.payload.exec.lots, r => {
            if (!r.builder) {
                return
            }
            let section = _.find(this.props.payload.public.sections, { id: r.section_id })
            if (!section) {
                return
            }
			var sec = "Section_" + section.section
            var builder = "Builder_" + r.builder.toString()

            if (!_.has(store, `${sec}.${builder}.remaining`)) {
                _.set(store, `${sec}.${builder}`, {
                    remaining: 0,
                    total: 0,
                    salesSix: 0,
                    salesTwelve: 0,
                    monthsRemaining: 0,
                    twelveWeeklyAverage: 0,
                    sixWeeklyAverage: 0,
                    vacant_lots: 0,
                    contract: 0,
                    closed: 0,
                    spec_homes: 0,
                    model_homes: 0,
                    takedown: 0,
                    slab: 0,
                    complete: 0,
                    lot_size: section.lot_size,
                })
            }
            if (r.status == "Available Lot" || r.status == "Available Home") {
                store[sec][builder].remaining++
            }
            if (r.status == "Available Lot") {
                store[sec][builder].vacant_lots++
            }
            if (r.status == "Available Home") {
                store[sec][builder].spec_homes++
            }
            if (r.status == "Sold") {
                store[sec][builder].closed++
            }
            if (r.status == "Model") {
                store[sec][builder].model_homes++
            }
            if (r.sale_pending == 1) {
                store[sec][builder].contract++
            }
            // lot status
            // Not sure if this is right.
            if (r.complete_date) {
                store[sec][builder].complete++
            } else if (r.start_date) {
                store[sec][builder].slab++
            } else if (r.takedown_date) {
                store[sec][builder].takedown++
            }
        })
        //console.log(store)
        // totals
        _.forEach(this.props.payload.exec.allSales, r => {
            if (r.builder == false) {
                return
            }
            var sec = "Section_" + r.section
            var builder = "Builder_" + r.builder.toString()
            //console.log(r)
            store[sec][builder].total++

            // sales in past 6 months
            if (r.sale_date >= six) {
                store[sec][builder].salesSix++
            }
            if (r.sale_date >= twelve) {
                store[sec][builder].salesTwelve++
            }
            // averages and months remaining
            store[sec][builder].sixWeeklyAverage = parseFloat((store[sec][builder].salesSix / 24).toFixed(2))
            store[sec][builder].twelveWeeklyAverage = parseFloat((store[sec][builder].salesTwelve / 48).toFixed(2))
            var avg = (store[sec][builder].sixWeeklyAverage + store[sec][builder].twelveWeeklyAverage) / 2
            var months = store[sec][builder].remaining / avg
            store[sec][builder].monthsRemaining = Math.ceil(months / 4)
        })
        //console.log(store)
        // Compile
        var ret = []
        //console.log(_.isEmpty(store))
        if (!_.isEmpty(store)) {
            _.forEach(store, (builder, section) => {
                _.forEach(builder, (v, k) => {
                    //console.log(v)
                    if (v.remaining == 0) {
                        return
                    }
                    v.builder = parseInt(k.replace("Builder_", ""))
                    let b = _.find(this.props.payload.public.builders.children, { id: v.builder })
                    v.builder = b.name
                    v.section = section.replace("Section_", "")
                    if (v.monthsRemaining == "Infinity") {
                        v.monthsRemaining = "∞"
                    }
                    ret.push(v)
                })
            })
        }

        console.log(ret)
        return ret
    }

    sectionPlusBuilder() {
        let suppply = this.supply()
        suppply = _.sortBy(suppply, "lot_size")
        //console.log(suppply)
        let labels = []
        let store = {
            takedown: [],
            slab: [],
            complete: [],
            closed: [],
            total: [],
        }

        _.forEach(suppply, v => {
            let label = `Section ${v.section} - ${v.builder}`
            labels.push(label)
            store.takedown.push(v.takedown)
            store.slab.push(v.slab)
            store.complete.push(v.complete)
            store.closed.push(v.closed)
            //store.total.push(v.total)
        })

        let datasets = [
            {
                label: "Takedown",
                stack: "Stack 0",
                backgroundColor: "#3295EC",
                data: store.takedown,
            },
            {
                label: "Slab Poured",
                stack: "Stack 0",
                backgroundColor: "#76B9F1",
                data: store.slab,
            },
            {
                label: "Complete",
                stack: "Stack 0",
                backgroundColor: "#C297F5",
                data: store.complete,
            },
            {
                label: "Closed",
                stack: "Stack 0",
                backgroundColor: "#ec315d",
                data: store.closed,
            },
            /* {
                label: "Total",
                stack: "Stack 1",
                backgroundColor: "#dd31ec",
                data: store.total,
            }, */
        ]

        //console.log(store)
        const opts = {
            scales: {
                xAxes: [
                    {
                        stacked: true,
                        ticks: {
                            autoSkip: false,
                            maxTicksLimit: 40,
                        },
                    },
                ],
                yAxes: [
                    {
                        stacked: true,
                    },
                ],
            },
            legend: {
                display: true,
                position: "bottom",
            },
        }
        let data = {
            labels: labels,
            datasets: datasets,
        }
        //console.log(data)
        return (
            <div>
                <h3>Home Construction Status</h3>
                <Bar data={data} options={opts} />
            </div>
        )
    }

    filterChange = e => {
        if (!e.target.dataset.value) {
            return
        }
        let state = clone(this.state)
        let index = _.findIndex(state.columns, {Header: e.target.dataset.value})
        state.columns[index].display = !state.columns[index].display
        this.setState(state)
    }

    checkboxChange = e => {
         let state = clone(this.state)
         let index = _.findIndex(state.columns, { Header: e.target.name })
         state.columns[index].display = !state.columns[index].display
         this.setState(state)
    }

    renderFilters = () => {
        let checkboxes = []
        _.forEach(this.state.columns, v => {
            if(v.Header == 'Section' || v.Header == 'Builder') { return }
            let index = _.findIndex(this.state.columns, {Header: v.Header})
            checkboxes.push(
                <li
                    className="filterCheckboxes__item"
                    key={v.Header}
                    data-value={v.Header}
                    onClick={this.filterChange}>
                    <input
                        type="checkbox"
                        name={v.Header}
                        value={v.Header}
                        checked={this.state.columns[index].display}
                        onChange={this.checkboxChange}
                    />
                    {v.Header}
                </li>
            )
        })

        return checkboxes
    }

    activeColumns = () => {
        let ret = _.filter(this.state.columns, { display: true })
        //console.log(ret)
        return ret
    }

    toggleAll = checked => {
        let columns = clone(this.state.columns)
        _.forEach(columns, (v, k) => {
            if (v.Header == "Section" || v.Header == "Builder") {
                return
            }
            let index = _.findIndex(columns, {Header: v.Header})
            columns[index].display = checked
        })
        this.setState({ columns: columns })
    }

    render() {
        if(this.props.payloadStatus) {
            return (
				<div className="inventory">
					<Title title="Builder + Section Inventory Report" showDate={false} />
					<div className="statBreakout">
						<ul className="boxList__list">
							<li className="boxList__item">
								<span>{this.developerLots()}</span>
								<span>Developer Lots Available</span>
							</li>
							<li className="boxList__item">
								<span>{this.specHomesTotal()}</span>
								<span>Spec Homes Available</span>
							</li>
							<li className="boxList__item">
								<span>{this.comingSoon()}</span>
								<span>Homes Under Construction</span>
							</li>
						</ul>
					</div>

					<div className="content inventory__content">
						{/* <ul className="pillList">
                        <li className="pillList__item">Section + Builder</li>
                        <li className="pillList__item">Lot Size + Builder</li>
                    </ul> */}
						<ul className="filterCheckboxes filterCheckboxes--toggles">
							<li className="filterCheckboxes__item" onClick={() => this.toggleAll(true)}>
								<i className="fas fa-check" /> Toggle All
							</li>
							<li className="filterCheckboxes__item" onClick={() => this.toggleAll(false)}>
								<i className="fas fa-times" /> Toggle None
							</li>
						</ul>
						<ul className="filterCheckboxes">{this.renderFilters()}</ul>
						<ReactTable
							data={this.supply()}
							columns={this.activeColumns()}
							defaultPageSize={40}
							loadingText=""
							defaultSorted={[
								{
									id: "remaining",
									asc: true,
								},
							]}
						/>
						{this.sectionPlusBuilder()}
					</div>
				</div>
			)
        }
        else {
            return('')
        }
    }
}

function mapStateToProps(state) {
    return {
        currentDates: state.currentDates,
        compareDates: state.compareDates,
        payload: state.payload,
        payloadStatus: state.payloadStatus
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(Inventory)
